import { CardDescription } from "@/components/ui/card"
import { cn } from "@/lib/utils"

/**
 * Truncate text with a fade effect only for longer text.
 */
export default function TruncatedTextWithFade({
  children,
  className,
  wrapperClassName,
  cardDescriptionClassName,
}: {
  children: React.ReactNode
  className?: string
  wrapperClassName?: string
  cardDescriptionClassName?: string
}) {
  return (
    <div className={cn("relative overflow-hidden max-h-24", wrapperClassName)}>
      <CardDescription
        className={cn("text-foreground", cardDescriptionClassName)}
      >
        {children}
      </CardDescription>

      <div
        className={cn(
          "absolute -bottom-2 left-0 right-0 bg-gradient-to-t bg-fade-to-top-white from-white dark:from-background to-transparent pointer-events-none",
          className
        )}
      ></div>
    </div>
  )
}
